module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nostyle",
    attrs: {
      "href": _vm.project['link'],
      "target": _vm.project['link'] ? '_blank' : null
    }
  }, [_c('div', {
    staticClass: "project",
    on: {
      "mouseenter": function($event) {
        _vm.hover = true
      },
      "mouseleave": function($event) {
        _vm.hover = false
      }
    }
  }, [_c('div', {
    staticClass: "project-image"
  }, [(_vm.project['image']) ? _c('img', {
    attrs: {
      "src": _vm.project['image']
    }
  }) : (_vm.project['image_initial']) ? _c('span', {
    staticClass: "monospaced"
  }, [_vm._v("\n                " + _vm._s(_vm.project['image_initial']) + "\n            ")]) : _c('span', {
    staticClass: "monospaced"
  }, [_vm._v("\n                " + _vm._s(_vm.project['name'][0]) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "project-description"
  }, [_c('h3', {
    staticClass: "monospaced"
  }, [_vm._v(_vm._s(_vm.projectNameKebab))]), _vm._v(" "), _vm._l((_vm.project['description']), function(line) {
    return _c('p', [_vm._v(_vm._s(line))])
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d538aef","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProjectItem.vue
// module id = 21
// module chunks = 0